import { render, staticRenderFns } from "./pp-matriz-editar.vue?vue&type=template&id=a72b028e&"
import script from "./pp-matriz-editar.vue?vue&type=script&lang=js&"
export * from "./pp-matriz-editar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports